import { Stack } from "react-bootstrap";
import { Header } from "./Header";
import { Outlet } from "react-router";
import { useCustomContext } from "../../_helper/customizer";
import { Col, Container, Row } from "reactstrap";

export const Layout = () => {
  const customCtx = useCustomContext();

  return (
    <Container fluid>
      <Row>
        <Col xl={12} className="p-0">
          <Stack dir={customCtx.layout} className="vh-100">
            <div className="nav-wrapper" style={{ position: "fixed", top: 0, left: 0, zIndex: 1000, backgroundColor: "#faf8f6" }}>
              <Header />
            </div>
            <div style={{ marginTop: "94.5px" }}>
              <Outlet />
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  );
};
